import { render, staticRenderFns } from "./DiagramNode.vue?vue&type=template&id=13ff53f4&"
import script from "./DiagramNode.vue?vue&type=script&lang=js&"
export * from "./DiagramNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports